import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.scss']
})
export class TestimonialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  testimonials = [
    {
      "author": "学术编辑, 美国",
      "designation": "学术编辑, 美国",
      "message": "我一下就爱上Trinka了。祝贺你们开发出这个可以大幅协助编辑的程序，尤其是符合重要的语法惯例和具备精简字数功能的工具。",
      "photo": "clientPhotos/James-Smith.jfif"
    },
    {
      "author": "Rosa Diaz Sandoval",
      "designation": "物理和数学博士, 墨西哥",
      "message": "对于说其他语言的人来说，用正确的英语语法和风格编写文章不是一件容易的事。如果没有辅助功能，尤其是学术写作，很难在文件中发现小错误。我尝试将TrinkaAI作为自动更正工具，并对建议的更正和反馈感到非常满意。通过反馈，能了解为什么必须考虑建议的更改。",
      "photo": "clientPhotos/Rosa-Diaz-Sandoval.jfif"
    },
    {
      "author": "Farooq Rathore博士",
      "designation": "助理教授兼系主任, 巴基斯坦",
      "message": "我使用Trinka两个多月了。我主要用它来改进我为国内和国际生物医学期刊撰写的科学手稿的语言、语法和句法。界面很用户友好，并且软件高效且好用。根据需要编辑手稿的不同选项有助于决定我需要关注的地方。自动编辑的帮助很大，带有修订历史的补充页面很有用。Trinka一直在更新，我写这篇文章时就注意到添加了一个新功能“一致性”。最好的部分是所有这些都是完全免费的。我强烈鼓励作者和研究人员，特别是那些英语不好的人尝试一下，亲眼目睹惊人的结果。",
      "photo": "clientPhotos/Dr_Farooq_Rathore.jpg"
    },
    // {
    //   "author": "James Smith",
    //   "designation": "Academic Editor, USA",
    //   "message": "First, I love Trinka. Congratulations on developing something that extensively aids editing, especially critical grammar conventions and word count reductions.",
    //   "photo": "clientPhotos/James-Smith.jpg"
    // },
    // {
    //   "author": "Edith Davies",
    //   "designation": "PhD Scholar, UK",
    //   "message": "I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar checkers I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is widely used in academia.",
    //   "photo": "clientPhotos/Edith-Davies.jpg"
    // },
    {
      "author": "Milena Georgieva",
      "designation": "研究员",
      "message": "Trinka.ai是我最喜欢的语法和拼写编辑。该应用程序使用效果好，快速而明确！完全满意！",
      "photo": "clientPhotos/Georgieva-Milena.jpg"
    },
    {
      "author": "Dinesh Gupta",
      "designation": "放射科医师, 印度",
      "message": "这是一个超越Grammarly的语法检查工具！我用Trinka重新检查了用Grammarly检查过一些文件。看到来自印度的如此优越产品，我感到非常惊喜！",
      "photo": "clientPhotos/Dinesh-Gupta.jfif"
    },
        // {
    //   "author": "Dmitry Belousov",
    //   "designation": "OKI Publishing House, Russian Federation",
    //   "message": "We have been using the Trinka AI online service for more than a year to check the abstracts of medical articles and to check translations of articles from Russian to English. During this period, the Trinka AI service was excellent. We recommend it to our colleagues.",
    //   "photo": "clientPhotos/belousov.jpg"
    // },
    {
      "author": "Edith Davies",
      "designation": "博士生, 英国",
      "message": "我已经测试过Trinka，并对其出色的功能印象深刻。它比我使用的语法检查器做得更好。做得好！我已经告诉我研究实验室的同事使用Trinka。希望在学术界得到广泛应用。",
      "photo": "clientPhotos/Edith-Davies.jpg"
    },
        // {
    //   "author": "Abba Kasim",
    //   "designation": "Researcher, FUDMA, Nigeria",
    //   "message": "The Trinka platform is intuitive and easy to navigate. Most importantly, the plagiarism checker is a game-changer! It gives me confidence that my work is original and free from unintentional copying, which is crucial for academic integrity.",
    //   "photo": "clientPhotos/abba-kasim.jpg"
    // },
        {
      "author": "Noor Al-rishi",
      "designation": "化学学者, 沙特阿拉伯",
      "message": "Trinka AI建议的更正和反馈令我惊喜。使用简单，非常有益。",
      "photo": "clientPhotos/Noor-Al-rishi.png"
    },
    {
      "author": "Nwaji Jude",
      "designation": "研究员",
      "message": "使用Trinka是美妙的体验，如果不使用它评估稿件，我几乎无法提交任何手稿。总之，Trinka成了我的是救命稻草。",
      "photo": "clientPhotos/Nwaji-Jude.jpg"
    },
    {
      "author": "Stumpf Curtis",
      "designation": "研究员",
      "message": "我喜欢使用Trinka作为我编辑文稿的最终检查。它确实有助于找到在编辑过程中漏掉的剩余错误。我真的很喜欢这个平台。大拇指向下这个按钮非常有用。",
      "photo": "clientPhotos/Stumpf-Curtis.jfif"
    },
    {
      "author": "Gareth Dyke",
      "designation": "研究员",
      "message": "我认为Trinka.ai是一个非常有趣且很有发展潜力的主意，尤其是对于编辑/出版社/期刊。我使用这个平台检查我的编辑工作，非常有用。",
      "photo": "clientPhotos/Dyke-Gareth.jfif"
    },
    {
      "author": "Bhargava Sharma",
      "designation": "流行病学家, 印度",
      "message": "我对整体表现感到满意。我使用Grammarly已经有很长一段时间了，但是在学术或技术写作方面，Trinka绝对是更好的选择。学术文件设置和自动文件编辑是我最喜欢的功能。",
      "photo": "clientPhotos/Bhargava-Sharma.jfif"
    },
    {
      "author": "Ralph Bailey",
      "designation": "神经科医生, 美国",
      "message": "Trinka已成为我语法校正的首选工具。人工智能驱动的更正和语言增强使写作变得更加容易。现在，我可以更专注于研究，而不是纠正文稿中的错误。",
      "photo": "clientPhotos/Ralph-Bailey.jfif"
    },
    {
      "author": "Thomas Andres",
      "designation": "心脏学专家, 巴西",
      "message": "基于AMA风格指南的语法纠正和建议真的令人印象深刻！Trinka确实是医学写作最好的语法校正工具。",
      "photo": "clientPhotos/Thomas-Andres.jfif"
    }
  ]  

}
